import CryptoJS from 'crypto-js'

const UNKNOWN_USER_BUCKET = 'unknownUser'

const cryptoEdsKeys = {
  computed: {
    secretKey() {
      return this.$User.id + '_SECRET'
    }
  },
  methods: {
    encryptKeyInfo(dataToEncrypt, secret = this.secretKey) {
      return CryptoJS.AES.encrypt(dataToEncrypt, secret).toString()
    },
    decryptKeyInfo(dataToDecrypt, secret = this.secretKey) {
      const decryptedBytes = CryptoJS.AES.decrypt(dataToDecrypt, secret)
      const decryptedJsonString = decryptedBytes.toString(CryptoJS.enc.Utf8)
      return JSON.parse(decryptedJsonString)
    },
    canDecryptKeyInfo(dataToDecrypt, secret = this.secretKey) {
      try {
        this.decryptKeyInfo(dataToDecrypt, secret)
        return true
      } catch (e) {
        return false
      }
    },
    /**
     * Приводить `savedEdsKeys` у localStorage до об'єктної структури,
     * розділеної за користувачем:
     *   { [userId]: [encryptedStr, ...], unknownUser: [encryptedStr, ...] }
     *
     * - Старий масивний формат розбивається на «ключі поточного користувача»
     *   та «unknownUser» — залежно від того, чи може поточний користувач
     *   розшифрувати кожен запис.
     * - При кожному запуску також «забирає» із `unknownUser` ті записи,
     *   які поточний користувач здатен розшифрувати, тож кожен користувач
     *   поступово забирає свої залишки під час наступного входу.
     *
     * Чиста функція: повертає новий об'єкт і не змінює сховище.
     */
    migrateSavedEdsKeys(savedKeysLS) {
      if (!this.$User || !this.$User.id) {
        return savedKeysLS && typeof savedKeysLS === 'object' ? savedKeysLS : {}
      }
      const userId = this.$User.id
      let next

      if (Array.isArray(savedKeysLS)) {
        const owned = []
        const unknown = []
        for (const item of savedKeysLS) {
          if (this.canDecryptKeyInfo(item)) {
            owned.push(item)
          } else {
            unknown.push(item)
          }
        }
        next = { [userId]: owned }
        if (unknown.length) {
          next[UNKNOWN_USER_BUCKET] = unknown
        }
      } else if (savedKeysLS && typeof savedKeysLS === 'object') {
        next = { ...savedKeysLS }
      } else {
        next = {}
      }

      const unknownBucket = next[UNKNOWN_USER_BUCKET] || []
      if (unknownBucket.length) {
        const claimed = []
        const stillUnknown = []
        for (const item of unknownBucket) {
          if (this.canDecryptKeyInfo(item)) {
            claimed.push(item)
          } else {
            stillUnknown.push(item)
          }
        }
        if (claimed.length) {
          next[userId] = [...(next[userId] || []), ...claimed]
        }
        if (stillUnknown.length) {
          next[UNKNOWN_USER_BUCKET] = stillUnknown
        } else {
          delete next[UNKNOWN_USER_BUCKET]
        }
      }

      return next
    }
  }
}

export default cryptoEdsKeys
